import React, { useState, useEffect } from 'react';

import { getServices } from '../../../api/services/servicesApi';
import {
  postServiceRate,
  editServiceRate,
  deleteRate,
} from '../../../api/services/ratesApi';

import AdminServiceRatesCard from '../../../components/admin/cards/AdminServiceRatesCard/AdminServiceRatesCard';
import RateModal from '../../../components/admin/modals/RateModal/RateModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminPrices.css';

const AdminPrices = () => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedRate, setSelectedRate] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');

  const getAllServices = async () => {
    const allServices = await getServices();
    setServices(allServices);
  };

  useEffect(() => {
    getAllServices();
  }, []);

  const onAddClickHandler = (service) => {
    setSelectedService(service);
    setSelectedRate({});
    setEditModalMode('add');
    setIsEditModalOpen(true);
    setIsDeleteModalOpen(false);
  };

  const onEditClickHandler = (service, rate) => {
    setSelectedService(service);
    setSelectedRate(rate);
    setEditModalMode('edit');
    setIsEditModalOpen(true);
    setIsDeleteModalOpen(false);
  };

  const onDeleteClickHandler = (service, rate) => {
    setSelectedService(service);
    setSelectedRate(rate);
    setIsDeleteModalOpen(true);
    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedService(null);
    setSelectedRate(null);
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedService(null);
    setSelectedRate(null);
  };

  const handleSubmit = async (formData) => {
    const { rateId, ...rateData } = formData;
    try {
      if (editModalMode === 'edit') {
        await editServiceRate(selectedService._id, rateId, rateData);
        alert('Rate updated successfully!');
      } else {
        await postServiceRate(selectedService._id, rateData);
        alert('Rate created successfully!');
      }
      await getAllServices();
      setIsEditModalOpen(false);
    } catch (error) {
      console.error('Submit failed:', error);
    }
  };

  const onConfirmDelete = async () => {
    await deleteRate(selectedService._id, selectedRate._id);
    onDeleteModalClose();
    await getAllServices();
    alert(`Deleted! ${selectedRate?.name} deleted successfully!`);
  };

  return (
    <div className='prices-group'>
      <div className='admin-prices-container'>
        <h1 id='admin-prices-list-title'>Prices</h1>
        <div className='admin-services-rates-container'>
          {services.map((s) => (
            <AdminServiceRatesCard
              key={s._id}
              service={s}
              onAddClickHandler={onAddClickHandler}
              onEditClickHandler={onEditClickHandler}
              onDeleteClickHandler={onDeleteClickHandler}
            />
          ))}
        </div>
      </div>
      {isEditModalOpen && (
        <RateModal
          onClose={onModalClose}
          onSubmit={handleSubmit}
          service={selectedService}
          rate={selectedRate}
          mode={editModalMode}
        />
      )}
      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={onDeleteModalClose}
          onConfirm={onConfirmDelete}
          deleteItemTitle={selectedRate?.name}
        />
      )}
    </div>
  );
};

export default AdminPrices;
